import { render, staticRenderFns } from "./ChartMobile.vue?vue&type=template&id=15c50cf0&scoped=true"
import script from "./ChartMobile.vue?vue&type=script&lang=js"
export * from "./ChartMobile.vue?vue&type=script&lang=js"
import style0 from "./ChartMobile.vue?vue&type=style&index=0&id=15c50cf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c50cf0",
  null
  
)

export default component.exports